import { useState, useEffect, useContext } from 'react';
import {useTranslation} from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import PreteachSlide from './PreteachSlide';
import PreteachSliderNav from './PreteachSliderNav';
import ParrotBox from '../../UI/ParrotBox';

import ConvContext from '../../../store/conversation-context';
import useAnalyticsEventTracker from '../../../hooks/use-analytics';

const Preteach = (props) => {
  const {t: translate } = useTranslation();
  const dispatch = useDispatch();
  const { convContext } = useContext(ConvContext);
  const sentences = convContext.sentences;
  const [slideActive, setSlideActive] = useState(0);
  const [preteachFinished, setPreteachFinished] = useState(false);
  const [parrotText, setParrotText] = useState(translate('preteach-start'));
  const gaEventTracker = useAnalyticsEventTracker('Pre-Teach');
  let conversationData = useSelector((state) => state.conversationData);

  const slideHandler = (index) => {
    setSlideActive(index);

    //Handle end of slides
    if (index === sentences.length) {
      setPreteachFinished(true);
      setParrotText(translate('preteach-end'));
    } else {
      setPreteachFinished(false);
      setParrotText(translate('preteach-start'));
    }
    //Fire started progress event
    //Firing when moving from slide 1 to 2 as user has definitely started the lesson if navigating preteach
    // if( index === 1 ) {
    // 	props.updateUserProgress();
    // }
  };

  const triggerPreTeach = () => {
    gaEventTracker('Pre-teach start conversation', `${conversationData.location} ${conversationData.sceneName} Lesson ${conversationData.lesson}`)

    props.completePreteach();
  };

  useEffect(() => {
    if (preteachFinished === true) {
      dispatch({
        type: 'resetActiveSection',
      });
    }
  }, [preteachFinished]);

  return (
    <div className="preteach">
      {sentences && <ParrotBox text={parrotText} />}
      <div className="preteach__slides">
        {!sentences && <button className='button button--error' onClick={() => {location.reload()}}>Error loading sentences. Please reload.</button>}

        {sentences && sentences.map((slideData, index) => (
          <PreteachSlide
            key={`${index}`}
            slideKey={`${index}`}
            index={index}
            data={slideData}
            slideActive={slideActive}
            nextSlideHandler={slideHandler}
          />
        ))}
      </div>

      {preteachFinished && (
        <button onClick={triggerPreTeach} className="button button--success ">
          {translate('start-conversation')}
        </button>
      )}

      {sentences && <PreteachSliderNav
        dotsData={sentences}
        navButtonhandler={slideHandler}
        currentSlide={slideActive}
      />}
    </div>
  );
};

export default Preteach;
